import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './styles/TransferInventoryPage.css';
import { useNavigate } from 'react-router-dom'; 

const CreateProgramEventPage = () => {
    const [price, setPrice] = useState(0);
    const [itemName, setItemName] = useState('');
    const [itemType, setItemType] = useState('');
    const [program, setProgram] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        setItemType("EVENT_FEE");
    });
    
    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };
    
    const handlePriceChange = (e) => {
        const value = e.target.value.replace(/\./g, '');
        if (value === '') {
            setPrice(0);
        } else {
            e.target.value = formatCurrency(value); 
            setPrice(value); // Simpan nilai asli tanpa format
        }
    };

    const validateForm = () => {
        const errors = {};
        if (price === 0) errors.price = 'Price is required';
        if (itemName === 0) errors.price = 'Item Name is required';
        if (program === 0) errors.price = 'Program Name is required';
        return errors;
    };
   
    const handleSubmit = () => {
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            console.log('Validation Errors:', validationErrors);
        } else {
            const confirmation = window.confirm('Are you sure you want to proceed with this action?');
            if (!confirmation) {
                return;
            }
            
            const programData = {
                data: {
                    programData: {
                        program_name: program,
                        item_name: itemName,
                        cost_amount: price
                    },
                },
            };

            console.log(programData);
        
            api.post(`utils/createProgramEvent`, programData)
            .then(response => {
                const successMessage = response.data.message;
                console.log(successMessage);
                navigate('/success', { state: { message: successMessage } });
            })
            .catch(error => {
                console.error('Error updating price:', error);
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
            });
        }
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Create Kidola Event Program</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Program Data</h3>
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Program Name</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input
                                                type="text" 
                                                value={program}
                                                onChange={e => setProgram(e.target.value)} 
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    {errors.program && 
                                    <td>
                                        <div className="error-message">{errors.program}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Item Name</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text"
                                            value={itemName}
                                            onChange={e => setItemName(e.target.value)} 
                                        />
                                    </td>  
                                </tr>
                                <tr>
                                    {errors.itemName && 
                                    <td>
                                        <div className="error-message">{errors.itemName}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Item Type</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text"
                                            value={itemType} 
                                            readOnly
                                        />
                                    </td> 
                                </tr>
                                <tr>
                                    <td>
                                        <label>Item Price</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text" // Ubah ke text untuk format mata uang
                                            value={formatCurrency(price)}      
                                            onChange={handlePriceChange} 
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    {errors.price && 
                                    <td>
                                        <div className="error-message">{errors.price}</div>
                                    </td>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="search-container">
                    <button className="profile-button" onClick={handleSubmit}>Submit</button>
                </div>
            </div>
        </div>
    );
};

export default CreateProgramEventPage;
